import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_T3 Koxka Limpieza02.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class CleanKoaxka extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);

		this.shelvesGroup = {
			shelvesOne: [
				"Pizza_001",
				"Pizza_1001",
				"Pizza_2001",
				"Pizza_3001",
				"Pizza_4001",
				"Pizza_5001",
				"sandwich_1001",
				"sandwich_2001",
				"sandwich_3001",
				"Bolsa_4001",
				"Bolsa_001",
				"Bolsa_3001",
			],
			shelvesTwo: [
				"Bolsa_2001",
				"Bolsa_1001",
				"sandwich_10001",
				"sandwich_9001",
				"sandwich_8001",
				"sandwich_4001",
				"sandwich_5001",
				"sandwich_6001",
				"sandwich_7001",
				"Yoghurt_1001",
				"Yoghurt_7001",
				"Yoghurt_2001",
				"Yoghurt_20001",
				"Yoghurt_3001",
				"Yoghurt_4001",
				"Yoghurt_5001",
				"Yoghurt_6001",
				"Yoghurt_27001",
				"Yoghurt_26001",
				"Yoghurt_23001",
				"Yoghurt_18001",
				"Yoghurt_21001",
				"Yoghurt_17001",
				"Yoghurt_16001",
			],
			shelvesThree: [
				"Yoghurt_22001",
				"Yoghurt_14001",
				"Yoghurt_15001",
				"Yoghurt_10001",
				"Yoghurt_9001",
				"Yoghurt_8001",
				"Yoghurt_19001",
				"Yoghurt_13001",
				"Yoghurt_12001",
				"Yoghurt_24001",
				"Yoghurt_25001",
				"Yoghurt_11001",
				"Alimentos_inferiores",
			]
		}

		this.allProductChangueMaterial = [
			...this.shelvesGroup.shelvesOne,
			...this.shelvesGroup.shelvesTwo,
			...this.shelvesGroup.shelvesThree
		]
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			// Recorrer la lista de objetos en shelvesGroup y aplicar onChangueMaterial a cada uno
			Object.values(this.allProductChangueMaterial).flat().forEach(objectName => {
				const currentObject = gltf.scene.getObjectByName(objectName, true);
				if (currentObject) {
					this.onChangueMaterial(currentObject);
				}
			});

			this.Estantes = gltf.scene.getObjectByName("Estantes", true);
			this.onChangueMaterial(this.Estantes);
			this.Base_repisa = gltf.scene.getObjectByName("Base_repisa", true);
			this.onChangueMaterial(this.Base_repisa);
			this.Trapo = gltf.scene.getObjectByName("Trapo", true);
			this.Spray = gltf.scene.getObjectByName("Spray", true);
			this.Rollo = gltf.scene.getObjectByName("Rollo", true);

		});
	}

	onChangueMaterial(object) {
		const newMaterial = object.material.clone();
		newMaterial.transparent = true
		object.material = newMaterial
	}

	onClearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null
		}
	}

	onAnimationMovePosition(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.position,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimationMoveRotation(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.rotation,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimateEmissive(object) {
		this.onClearAnimation()

		if (!object) {
			return
		}

		this.animation = gsap.to(object, {
			emissiveIntensity: 2,
			yoyo: true,
			repeat: -1,
			duration: 0.9,
			ease: "power1.inOut",
		});
	}

	onOpacityObject(object, opacity = 1, duration = 1, callback = () => {

	}) {

		if (!object) {
			return
		}

		gsap.to(object.material, {
			opacity,
			duration,
			onComplete: () => {
				callback()
			},
		});
	}

	onVisibleMultiple(object = [], value = true) {
		object.forEach(objectName => {
			this.getObjectByName(objectName, true).visible = value
		})
	}

	onOpacityMultiple(object = [], opacity = 1, duration = 1, callback = () => {

	}) {

		if (!object) {
			return
		}

		if (object.length === 0) {
			return
		}

		const objectSelectMaterial = object.map(objectName => {
			return this.getObjectByName(objectName, true).material
		})

		gsap.to(objectSelectMaterial, {
			opacity,
			duration,
			onComplete: () => {
				callback()
			},
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("koaxka");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("Rollo", this.Rollo);
	}

	helperMethod(name, object, limitPosicion = 20, limitRotation = 5) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -limitPosicion, limitPosicion).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limitPosicion, limitPosicion).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limitPosicion, limitPosicion).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -limitRotation, limitRotation).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -limitRotation, limitRotation).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -limitRotation, limitRotation).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
